import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Text,
  Tooltip,
} from '@chakra-ui/react'
import ConfirmButton from '../../Forms/components/ConfirmButton'
import { ISharedDiagnostic } from '../../../types/diagnostics'
import { InfoOutlineIcon } from '@chakra-ui/icons'
import { useTranslation } from 'react-i18next'

interface HeaderWhiteBoardCardProps {
  sharedDiagnostic: ISharedDiagnostic
  onOpen: () => void
}

const HeaderWhiteBoardCard = ({
  sharedDiagnostic,
  onOpen,
}: HeaderWhiteBoardCardProps) => {
  const isInProcess = sharedDiagnostic.status === 'in_process'
  const isClosed = sharedDiagnostic.status === 'closed'
  const isExpired = sharedDiagnostic.status === 'expired'
  const pendingInvitation = sharedDiagnostic.receiverStatus === 'pending'
  const { t } = useTranslation()

  return (
    <>
      <Flex justify={'space-between'} align={'center'} mb={4}>
        <Box flex={1}>
          {!isInProcess && (
            <Flex align={'center'} gap={2} mb={3}>
              <InfoOutlineIcon color={'blue.500'} boxSize={5} />
              <Text
                fontSize={'md'}
                color={'gray.600'}
                fontWeight="500"
                bg={isClosed ? 'green.50' : 'orange.50'}
                px={3}
                py={1}
                borderRadius="full"
                borderWidth="1px"
                borderColor={isClosed ? 'green.200' : 'orange.200'}
              >
                {isClosed
                  ? t('whiteboard.closedMsg')
                  : isExpired
                    ? t('whiteboard.expiredMsg')
                    : null}
              </Text>
            </Flex>
          )}
          <Text
            fontWeight={'semibold'}
            fontSize={'2xl'}
            bgGradient="linear(to-r, #7c3aed, #06b6d4)"
            bgClip="text"
          >
            {t('whiteboard.title')}
          </Text>
        </Box>
        <Box minW={'200px'}>
          {isInProcess && (
            <Tooltip
              isDisabled={!pendingInvitation}
              hasArrow
              label={t('whiteboard.pendingMsgTooltip')}
              placement="top"
              bg="gray.700"
            >
              <Box width="100%">
                <ConfirmButton
                  text={t('whiteboard.finalize')}
                  onClick={onOpen}
                  isDisabled={pendingInvitation}
                />
              </Box>
            </Tooltip>
          )}
        </Box>
      </Flex>
      <Accordion allowToggle>
        <AccordionItem
          border="none"
          bg="gray.50"
          borderRadius="xl"
          overflow="hidden"
        >
          <AccordionButton
            py={3}
            px={4}
            _hover={{
              bg: 'purple.50',
            }}
            _expanded={{
              bg: 'purple.50',
              borderBottomWidth: '1px',
              borderColor: 'purple.100',
            }}
            transition="all 0.2s"
          >
            <Text fontSize={'md'} fontWeight={'semibold'} color="purple.700" flex={1} textAlign="left">
              {t('whiteboard.caseDescription')}
            </Text>
            <AccordionIcon color="purple.500" />
          </AccordionButton>
          <AccordionPanel py={4} px={4} bg="white">
            <Text fontSize={'md'} color={'gray.700'} lineHeight="tall">
              {sharedDiagnostic.description}
            </Text>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </>
  )
}

export default HeaderWhiteBoardCard
